import * as React from "react";
import PropTypes from 'prop-types';

const SvgCloseIcon2022 = props => {
  if (props.id !== "_svgcloseicon2022") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path d="M6.949 8.08L14.87 16l-7.92 7.92s-.566.565 0 1.131c.566.566 1.131 0 1.131 0l7.92-7.92 7.92 7.92s.565.566 1.131 0c.566-.566 0-1.131 0-1.131L17.131 16l7.92-7.92s.566-.565 0-1.131c-.566-.566-1.131 0-1.131 0L16 14.87 8.08 6.95s-.565-.566-1.131 0c-.566.566 0 1.131 0 1.131z" fill="#202020" /></svg>;
};

SvgCloseIcon2022.displayName = "_svgcloseicon2022";
SvgCloseIcon2022.propTypes = {
  id: PropTypes.string
};
SvgCloseIcon2022.defaultProps = {
  id: ''
};
export default SvgCloseIcon2022;